/* Single Course Bundle - Scripts específicos para página single de curso */
import './theme/scripts/mega-menu';
import Swiper from 'swiper/swiper-bundle.mjs';
import 'swiper/swiper-bundle.min.css';
import './theme/scripts/singleCourse';
import './theme/scripts/modal';
import './theme/scripts/subscribe';
import './theme/scripts/index-content';
import './theme/scripts/utmTracker';

// Inicializar Faculty carousel
const initFacultyCarousel = () => {
  const facultyCarouselElement = document.querySelector('.Faculty-carousel');

  if (!facultyCarouselElement) {
    return null;
  }

  try {
    const swiper = new Swiper('.Faculty-carousel', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      loop: false,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '.Faculty-carousel .swiper-button-next',
        prevEl: '.Faculty-carousel .swiper-button-prev',
      },
    });

    return swiper;
  } catch (error) {
    console.error('[Faculty] Error initializing:', error);
    return null;
  }
};

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initFacultyCarousel();
  });
} else {
  initFacultyCarousel();
}
